import styled from 'styled-components';

export const GifSection = styled.div`
  video {
    object-fit: cover;
    object-position: center;
    position: absolute;
    z-index: 1;
    min-height: 50px;
  }
`;
